export const categories = [
  {
    id: 'zhengzhi-neimu',
    name: '政治内幕',
    slug: 'zhengzhi-neimu',
    description: '深度解析政治生态，揭露权力背后的真实博弈与隐秘交易',
    icon: 'ri-government-line',
    articleCount: 128,
  },
  {
    id: 'shangye-heimu',
    name: '商业黑幕',
    slug: 'shangye-heimu',
    description: '资本运作暗箱操作、企业灰色地带与行业潜规则全记录',
    icon: 'ri-briefcase-line',
    articleCount: 95,
  },
  {
    id: 'keji-jiemi',
    name: '科技揭秘',
    slug: 'keji-jiemi',
    description: '技术背后的隐私窃取、数据黑产与科技巨头不为人知的秘密',
    icon: 'ri-cpu-line',
    articleCount: 73,
  },
  {
    id: 'shehui-baoliao',
    name: '社会爆料',
    slug: 'shehui-baoliao',
    description: '社会热点事件背后的真相追踪与深层调查报道',
    icon: 'ri-eye-line',
    articleCount: 156,
  },
  {
    id: 'yule-quan',
    name: '娱乐圈',
    slug: 'yule-quan',
    description: '娱乐圈资本博弈、明星黑料与行业潜规则的深度起底',
    icon: 'ri-movie-line',
    articleCount: 89,
  },
  {
    id: 'guoji-fengyun',
    name: '国际风云',
    slug: 'guoji-fengyun',
    description: '国际局势暗流涌动，地缘政治博弈背后的大国较量',
    icon: 'ri-global-line',
    articleCount: 67,
  },
];

export const categoryMap: Record<string, typeof categories[0]> = {};
categories.forEach((cat) => {
  categoryMap[cat.slug] = cat;
});